import {useMutation, useQueryClient} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";

import {shiftsService} from "../services";

export function useDeletePatrolVisit() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({shiftId, visitId}: {shiftId: number; visitId: number}) =>
      shiftsService.deletePatrolVisit(shiftId, visitId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ["active-shift"]});
    },
    onError: errorHandler,
  });
}
